import { render } from "./GoalManagementV2.vue?vue&type=template&id=2b3456ee"
import script from "./GoalManagementV2.vue?vue&type=script&lang=js"
export * from "./GoalManagementV2.vue?vue&type=script&lang=js"

import "./GoalManagementV2.vue?vue&type=style&index=0&id=2b3456ee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__